import { Injectable, computed, inject, signal } from '@angular/core';

import { CurrentUserStore } from '../../../core/session/current-user.store';

@Injectable({
  providedIn: 'root',
})
export class SidebarSessionService {
  private currentUserStore = inject(CurrentUserStore);

  private rawUsername = signal('');
  readonly username = computed(() => this.currentUserStore.me()?.user.name || this.rawUsername() || 'Użytkownik');
  readonly userRole = computed(() => {
    const me = this.currentUserStore.me();
    if (!me) {
      return '';
    }
    if (me.globalRoles.includes('ADMIN')) {
      return 'Administrator';
    }
    if (me.activeDeveloperId !== null) {
      return 'Deweloper';
    }
    return '';
  });
  readonly userInitials = computed(() => this.resolveInitials(this.username()));

  loadSession(): void {
    this.rawUsername.set('');
  }

  private resolveInitials(fullName: string): string {
    if (!fullName.trim()) {
      return 'U';
    }

    return fullName
      .trim()
      .split(' ')
      .map((name) => name.charAt(0))
      .join('')
      .toUpperCase()
      .slice(0, 2);
  }
}
